var NProgress = require('nprogress');

var stack = 0;

var exports = {};

exports.start = function () {
  ++stack;
  NProgress.start();
};

exports.done = function () {
  if (--stack <= 0) {
    stack = 0;
    NProgress.done();
  }
};

exports.inc = NProgress.inc;

export default exports
